import { Controller } from "@hotwired/stimulus";

// Shows/hides dependent fields based on a control checkbox.
//   <div data-controller="field-toggle">
//     <input type="checkbox" data-field-toggle-target="control"
//            data-action="field-toggle#refresh">
//     <div data-field-toggle-target="dependent"> ...shown only when checked... </div>
//   </div>
export default class extends Controller {
  static targets = ["control", "dependent"];

  connect() {
    this.refresh();
  }

  refresh() {
    const on = this.hasControlTarget && this.controlTarget.checked;
    this.dependentTargets.forEach((el) => {
      el.hidden = !on;
    });
  }
}
